// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Author_wrapper__obsBn","imgContainer":"Author_imgContainer__9DWmy"};